import styled, { device } from '@styled'

export const PageWrapper = styled.div`
  border: 1px solid rgb(190, 190, 190);
  background: white;
  content: '';
  position: absolute;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow: hidden;
  ${({ pageIndex }) =>
    pageIndex % 2 === 0
      ? ` 
    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      transition: all 0.3s ease;
      left: 0px;
      top: 0;
      right: 0%;
      height: 100%;
      z-index: 1;
    }
    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      transition: all 0.3s ease;
      right: 0px;
      top: 0;
      left: 0%;
      height: 100%;
      z-index: 1;
      box-shadow: -10px 0 25px rgba(0,0,0,0.3) inset;
    }
    `
      : `
    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      transition: all 0.3s ease;
      left: 0px;
      top: 0;
      right: 0%;
      height: 100%;
      z-index: 1;
    }
    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      transition: all 0.3s ease;
      right: 0px;
      top: 0;
      left: 0%;
      height: 100%;
      z-index: 1;
      box-shadow: 10px 0 25px rgba(0,0,0,0.3) inset;
    }
    `}
`

export const ButtonBar = styled.div`
  display: contents;

  @media screen and (max-width: 575px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 12px max(12px, env(safe-area-inset-bottom, 0px));
    flex-shrink: 0;
  }
`

export const ButtonWrapper = styled.a`
  position: fixed;
  z-index: 1000;
  display: flex;
  color: grey;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  box-shadow:
    0 2px 5px 0 rgba(0, 0, 0, 0.26),
    0 2px 10px 0 rgba(0, 0, 0, 0.16);
  font-size: 20px;
  transition:
    box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1),
    background 150ms cubic-bezier(0.4, 0, 0.2, 1),
    color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  ${(props) => {
    switch (props.type) {
      case 'left':
        return `
                    left: max(32px, env(safe-area-inset-left, 0px));
                    top: 50%;
                    transform: translateY(-50%);
                    margin: 0;
                    ${device.small} {
                      left: max(20px, env(safe-area-inset-left, 0px));
                    }
                `
      case 'right':
        return `
                    right: max(20px, env(safe-area-inset-right, 0px));
                    top: 50%;
                    transform: translateY(-50%);
                    margin: 0;
                    ${device.small} {
                      right: max(20px, env(safe-area-inset-right, 0px));
                    }
                `
      case 'top-right':
        return `
                    top: max(12px, env(safe-area-inset-top, 0px));
                    right: max(20px, env(safe-area-inset-right, 0px));
                    transform: none;
                    margin: 0;
                    ${device.small} {
                      top: max(12px, env(safe-area-inset-top, 0px));
                      right: max(20px, env(safe-area-inset-right, 0px));
                    }
                `
      case 'top-right-2':
        return `
                    top: calc(max(12px, env(safe-area-inset-top, 0px)) + 64px);
                    right: max(40px, env(safe-area-inset-right, 0px));
                    transform: none;
                    margin: 0;
                    ${device.small} {
                      top: calc(max(12px, env(safe-area-inset-top, 0px)) + 54px);
                      right: max(20px, env(safe-area-inset-right, 0px));
                    }
                `
    }
  }};
  ${device.small} {
    width: 35px;
    height: 35px;
    font-size: 22px;
  }
  ${device.medium} {
    width: 40px;
    height: 40px;
    font-size: 23px;
  }
  ${device.large} {
    width: 45px;
    height: 45px;
    font-size: 25px;
  }

  @media screen and (max-width: 575px) {
    position: relative;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    transform: none !important;
    margin: 0;
    flex-shrink: 0;
  }

  &:hover {
    cursor: pointer;
    color: rgb(181 90 48 / 100%);
    box-shadow:
      0 2px 10px 0 rgba(181, 90, 48, 0.26),
      0 2px 15px 0 rgba(181, 90, 48, 0.16);
  }
`
